export function toPascalCase(str) {
  return str
    .split(/[-\s]/) // Split on both hyphens and spaces
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter and lowercase the rest
    .join(""); // Join all the words together
}
